/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tools_Abilities_CtaInputs */

const en_control_tools_abilities_cta = /** @type {(inputs: Control_Tools_Abilities_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare abilities`)
};

const zh_control_tools_abilities_cta = /** @type {(inputs: Control_Tools_Abilities_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较能力`)
};

/**
* | output |
* | --- |
* | "Compare abilities" |
*
* @param {Control_Tools_Abilities_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tools_abilities_cta = /** @type {((inputs?: Control_Tools_Abilities_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tools_Abilities_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tools_abilities_cta(inputs)
	return zh_control_tools_abilities_cta(inputs)
});
export { control_tools_abilities_cta as "control.tools.abilities.cta" }